import * as React from "react";
// import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import styles from "../../../styles/customerStyles.module.css";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import { Divider } from "@mui/material";
import dayjs from "dayjs";
import UpgradeBalanceDetails from "./UpgradeBalanceDetails";
import { capitalizeString } from "../utils/capitalizeString";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "60%",
  textAlign: "center",
  bgcolor: "background.paper",
  border: "none",
  boxShadow: 24,
  //   backgroundColor:"none",
  padding: "20px 50px",
  borderRadius: "10px",
};

export default function PaymentDetailsModal({ value, products, transaction }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const fulfilledOrders = products?.orders?.filter(
    (order) => order.fulfillment_status === "Fulfilled"
  )?.length;

  const processingOrders = transaction?.orders?.some(
    (order) => order.fulfillment_status === "Processing"
  );

  const unfulfilledOrders =
    products?.orders?.filter(
      (order) =>
        order.fulfillment_status === "Processing" &&
        order.fulfillment_status === "Failed"
    )?.length > 0;

  const failedOrders = transaction?.orders?.some(
    (order) => order.fulfillment_status === "Failed"
  );

  const allFailedOrders = transaction?.orders?.every(
    (order) => order.fulfillment_status === "Failed"
  );

  const withdrawTransaction =
    value.toUpperCase() === "SUCCESS" &&
    transaction.transaction_type?.toLowerCase() === "withdraw" &&
    !unfulfilledOrders;

  const deposit =
    value.toUpperCase() === "SUCCESS" &&
    transaction.transaction_type?.toLowerCase() === "deposit";

  return (
    <>
      <div
        style={{
          width: "auto",
          background: `${
            value.toUpperCase() === "REJECT" || value === "REJECTED" ||
            (transaction?.transaction_for === "Order Fulfillment" &&
              allFailedOrders)
              ? "#FCE1DB"
              : (withdrawTransaction && !processingOrders) ||
                deposit ||
                transaction.transaction_type.toUpperCase() === "REFUND" || transaction.transaction_type === "MANUAL_WITHDRAW"
              ? "#DCF0E7"
              : "#FCEED3"
          }`,
          borderRadius: "8px",
          color: `${
            (transaction?.transaction_for === "Order Fulfillment" &&
              allFailedOrders) ||
            value.toUpperCase() === "REJECT" || value === "REJECTED"
              ? "#B9241F"
              : (withdrawTransaction &&
                  !allFailedOrders &&
                  !processingOrders) ||
                deposit ||
                transaction.transaction_type.toUpperCase() === "REFUND" || transaction.transaction_type === "MANUAL_WITHDRAW"
              ? "#20826D"
              : "#B76E00"
          }`,
        }}
        onClick={handleOpen}
        className={styles.fulfillment}
      >
        {capitalizeString(
          transaction.transaction_type.toUpperCase() === "DEPOSIT" ||
            transaction.transaction_type.toUpperCase() === "REFUND" || transaction.transaction_type === "MANUAL_WITHDRAW"
            ? value
            : transaction?.transaction_for === "Order Fulfillment" &&
              allFailedOrders
            ? "Failed"
            : !unfulfilledOrders &&
              transaction?.transaction_for === "Order Fulfillment" &&
              failedOrders &&
              !processingOrders
            ? `${fulfilledOrders || 0}/${transaction?.orders?.length} Completed`
            : !unfulfilledOrders &&
              transaction?.transaction_for === "Order Fulfillment" &&
              !failedOrders &&
              !processingOrders
            ? "Completed"
            : "Processing"
        )}
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Box
            sx={{
              ...style,
              height: products?.orders?.length > 3 ? "70%" : "auto",
              overflowY: products?.orders?.length > 3 ? "scroll" : "hidden",
            }}
          >
            <h2
              className={styles.welcome_popup}
              style={{ marginBottom: "20px" }}
            >
              Payment Details
            </h2>
            {products?.orders?.length > 0 ? (
              <div>
                <div className="flexbox">
                  <h4 style={{ fontWeight: "400", fontSize: "16px" }}>
                    Total Orders:{" "}
                    <strong>
                      {fulfilledOrders || 0} / {products?.orders?.length}
                    </strong>
                  </h4>

                  <h4 style={{ fontWeight: "400", fontSize: "16px" }}>
                    Product Cost:
                    <strong style={{ marginLeft: "5px" }}>
                      €{transaction?.total_product_cost?.toFixed(2)}
                    </strong>
                  </h4>
                  <h4 style={{ fontWeight: "400", fontSize: "16px" }}>
                    Shipping Cost (
                    {transaction?.selected_shipping_method === "regular"
                      ? "R"
                      : "P"}
                    ) :
                    <strong style={{ marginLeft: "5px" }}>
                      €{transaction?.total_shipping_cost?.toFixed(2)}
                    </strong>
                  </h4>
                  <h4 style={{ fontWeight: "400", fontSize: "16px" }}>
                    Total Amount:{" "}
                    <strong>€{products?.amount?.toFixed(2)}</strong>
                  </h4>
                  {products?.payment_method === "card" && (
                    <h4 style={{ fontWeight: "400", fontSize: "16px" }}>
                      Processing Fees:
                      <strong> €{products?.processing_fees?.toFixed(2)}</strong>
                    </h4>
                  )}
                  <h4 style={{ fontWeight: "400", fontSize: "16px" }}>
                    Payment Method: <strong>{products?.payment_method}</strong>
                  </h4>
                </div>
                {products?.orders?.map((order) => (
                  <div key={order._id}>
                    <div className={styles.order_fulfilment_box}>
                      {/* <Checkbox defaultChecked /> */}
                      <div style={{ width: "100%" }}>
                        <div className={styles.selected_right_contents}>
                          <h5 style={{ color: "#3366FF", fontSize: "16px" }}>
                            Order Number
                          </h5>
                          <h5 style={{ color: "#3366FF", fontSize: "16px" }}>
                            #
                            {order?.order_number ||
                              order?.shopify_order_number ||
                              "Not available"}
                          </h5>
                        </div>
                        <Divider />
                        <div className={styles.selected_right_contents}>
                          <h5 style={{ fontSize: "14px" }}>
                            Total Product cost
                          </h5>
                          <h5 style={{ fontSize: "14px" }}>
                            €{order?.pricing?.product_cost?.toFixed(2)}
                          </h5>
                        </div>
                        <div className={styles.selected_right_contents}>
                          <h5 style={{ fontSize: "14px" }}>Shipping Cost</h5>
                          <h5 style={{ fontSize: "14px" }}>
                            €
                            {transaction?.selected_shipping_method === "premium"
                              ? (
                                  Number(
                                    order?.pricing?.total_shipping_cost?.toFixed(
                                      2
                                    )
                                  ) +
                                    Number(
                                      order?.pricing?.total_shipping_cost_non_electric_premium?.toFixed(
                                        2
                                      )
                                    ) || 0
                                ).toFixed(2)
                              : order?.pricing?.total_shipping_cost?.toFixed(2)}
                          </h5>
                        </div>
                        {order?.shipping_method && (
                          <div className={styles.selected_right_contents}>
                            <h5 style={{ fontSize: "14px" }}>
                              Shipping Method
                            </h5>
                            <h5 style={{ fontSize: "14px" }}>
                              {order?.shipping_method}
                            </h5>
                          </div>
                        )}
                        <div className={styles.selected_right_contents}>
                          <h5 style={{ fontSize: "14px" }}>Total Variants</h5>
                          <h5 style={{ fontSize: "14px" }}>
                            {order?.line_items?.length}
                          </h5>
                        </div>
                        <div className={styles.selected_right_contents}>
                          <h5 style={{ fontSize: "14px" }}>Date</h5>
                          <h5 style={{ fontSize: "14px" }}>
                            {dayjs(products?.createdAt).format("YYYY-MM-DD") ||
                              "Not available"}
                          </h5>
                        </div>
                        <div className={styles.selected_right_contents}>
                          <h5 style={{ fontSize: "14px" }}>
                            Transaction number
                          </h5>
                          <h5 style={{ fontSize: "14px" }}>
                            {order?.transaction_number ||
                              transaction?.transaction_id ||
                              "Not available"}
                          </h5>
                        </div>
                        <div className={styles.selected_right_contents}>
                          <h5 style={{ fontSize: "14px" }}>
                            Fulfillment Status
                          </h5>
                          <h5
                            style={{
                              fontSize: "14px",
                              color: `${
                                order?.fulfillment_status === "Failed"
                                  ? "tomato"
                                  : order?.fulfillment_status === "Processing"
                                  ? "orange"
                                  : "green"
                              }`,
                            }}
                          >
                            {order?.fulfillment_status || "Fulfilled"}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <UpgradeBalanceDetails balance={products} />
            )}
          </Box>
        </Fade>
      </Modal>
    </>
  );
}
